import { useMemo } from 'react';

/** Returns a unique string for each component instance it is called in, to be used as a key for
 * tracking metadata about the instances.
 */
export const useUniqueId = () => useMemo(() => String(Math.random()), []);
